import React from 'react';
import {FormattedMessage} from 'react-intl';
import useActiveLinkClass from '../../../_common/components/_custom-hooks/useActiveLinkClass';
import {pathnames as P} from '../../../_common/constants/pathnames';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const OrderDetailsLink = () => {
  const {activeClassName} = useActiveLinkClass({url: P.ORDER_DETAILS});

  return activeClassName && (
    <AsideMenuLink
      pathname={P.ORDER_DETAILS}
      isSubSection={true}
      icon={'Folder_red.svg'}
      label={<FormattedMessage id="order-details-page-link" defaultMessage="Order details"/>}
    />
  );
};

export default OrderDetailsLink;
